/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMoodSmileBeam = createReactComponent("mood-smile-beam", "IconMoodSmileBeam", [
  ["path", { d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", key: "svg-0" }],
  ["path", { d: "M10 10c-.5 -1 -2.5 -1 -3 0", key: "svg-1" }],
  ["path", { d: "M17 10c-.5 -1 -2.5 -1 -3 0", key: "svg-2" }],
  ["path", { d: "M14.5 15a3.5 3.5 0 0 1 -5 0", key: "svg-3" }]
]);

export { IconMoodSmileBeam as default };
//# sourceMappingURL=IconMoodSmileBeam.js.map
